import { lazy } from 'react'
import RequireAuthentication from '@/router/guards/RequireAuthentication'
const ScheduleExams = lazy(() => import('./pages/ScheduleExams'))
const ExamConfirmation = lazy(() => import('./pages/ExamConfirmation'))

const ExamsPartnersRoutes = [
  <RequireAuthentication
    path="/agendar-exames-com-parceiro"
    key="/agendar-exames-com-parceiro"
    exact
    component={ScheduleExams}
  />,
  <RequireAuthentication
    path="/agendar-exames-com-parceiro"
    key="/agendar-exames-com-parceiro"
    exact
    component={ScheduleExams}
  />,
  <RequireAuthentication
    path="/agendar-exames-com-parceiro/:partner/confirmacao"
    key="/agendar-exames-com-parceiro/:partner/confirmacao"
    exact
    component={ExamConfirmation}
  />,
]

export default ExamsPartnersRoutes
